$(document).ready(function () {


  $('#search_input').on('input', function (e) {
    var input = $(this);
    if (input.val().length > 0) {
      var closeBtn = $('#close_button');
      closeBtn.show();
      $('#close_button').on('click', function (e) {
        input.val("");
        $(this).off('click');
        $(this).hide();
      });
    }
  });

  $('#search-form').on("submit", function (ev) {
    ev.preventDefault();

    var input = $('#search_input');
    if (input.val().length > 2) {
      $('#faqs').empty();
      var test = questions.filter(function (item) {
        return (checkWord(input.val(), item.question.toLocaleLowerCase()) || checkWord(input.val(), item.answer.toLocaleLowerCase()))
      });

      if (test.length > 0) {
        ShowQuestions(test);
        $('[id^="home"]').hide();
      }


    } else {
      return;
    }
  });

  function ShowQuestions(questionArray) {
    var ulElement = $('#faqs')

    $.each(questionArray, function (index, value) {
      ulElement.append("<li><dl><dt href='" + value.id + "' data-toggle='collapse'>" + value.question + "<span class='icon'></span></dt><dd id='" + value.id.substring(1, value.id.length) + "' class='collapse'><p>" + value.answer + " </p></dd><dl></li>");
    });
    $('#render-search').show();
  }

  $('#render-search').on('click','#jumpToQuestion',function(e){
    e.preventDefault();
    showSingleQuestion($(this).attr('data-jump'));
  })


  function showSingleQuestion(questionId) {
    $('[id^="home"]').hide();
    $('#faqs').empty();
    ShowQuestions(getObjects(questions, 'id', questionId));
  }

  function getObjects(obj, key, val) {
    var objects = [];
    for (var i in obj) {
      if (!obj.hasOwnProperty(i)) continue;
      if (typeof obj[i] == 'object') {
        objects = objects.concat(getObjects(obj[i], key, val));
      } else if (i == key && obj[key] == val) {
        objects.push(obj);
      }
    }
    return objects;
  }


  function checkWord(word, str) {
    const allowedSeparator = '\\\s,;"\'|';

    const regex = new RegExp(
      `(^.*[${allowedSeparator}]${word}$)|(^${word}[${allowedSeparator}].*)|(^${word}$)|(^.*[${allowedSeparator}]${word}[${allowedSeparator}].*$)`,

      // Case insensitive
      'i',
    );

    return regex.test(str);
  }

  function searchFunction(request, response) {
    var test = questions.filter(function (item) {
      return checkWord(request.term, item.question.toLocaleLowerCase()) || checkWord(request.term, item.answer.toLocaleLowerCase())
    })

    const arraySelect = test.map(item => {
      const container = {};

      container.value = item.question;
      container.label = item.id;
      return container;
    })

    var uniqueArrayOfObjects = arraySelect.filter(function (obj, index, self) 
    { return index === self.findIndex(function (t) { return t['value'] === obj['value'] }); });



    response(uniqueArrayOfObjects);
  }

  function showFaqCategories() {
    $('#category_show').hide();
    $('#render-search').hide();
    $('[id^="home"]').show();
    $('[id^="subCategory"]').hide();
    $('[id^="click_"]').remove();
    $('[id^="sub_"]').remove();
    $('#faqs').empty();
    $('[id^="nav_details"]').hide();
  };

  $('#faqBreadCrum_faq').on('click', function (e) {
    e.preventDefault();
    showFaqCategories();
  });
  $('#idSeeAllFAQs').on('click', function (e) {
    e.preventDefault();
    moveToElement('faqBreadCrum_faq');
    showFaqCategories();

  });

  function moveToElement(element) {
    $('html, body').animate({
      scrollTop: $("#" + element + "").offset().top
    }, 500);
  }

  $('#jumpToQuestion').on('click',function(e){
    e.preventDefault();
    
  });

  function jumpToQuestion (questionId){
    showSingleQuestion(questionId);
  }


  $('#search_input').autocomplete({
    minLength: 3,
    source: searchFunction,
    select: function (event, ui) {
      showSingleQuestion(ui.item.label);
      //return false;
    }
  }).data("ui-autocomplete")._renderItem = function (ul, item) {
    return $("<li>")
      .append("<a>" + item.value + "</a>")
      .appendTo(ul);
  };


  $('#search_input').keyup(function (e) {
    if (e.which === 13) {
      $('#search_input').autocomplete("close");
    }
  });

  $('[id^="cat_"]').on('click', function (e) {
    e.preventDefault();
    var id = $(this).attr('id')
    var category = id.substring(id.indexOf('_') + 1, id.lenght);

    var filteredArray = questions.filter(function (item) {
      return item.category == category;
    });

    var tittle = $(this).find("h6").html();

    addBreadCrum(id, tittle);

    $('#category_show').hide();
    ShowQuestions(filteredArray);

  })

  $('[id^="subCategory"]').on('click', function (e) {
    e.preventDefault();

    $(e.target)
      .closest("article")
      .toggleClass("opened")
      .find("ul")
      .stop()
      .slideToggle(300);
  })

  function showSubcategory(subCatClass) {
    //$("[id*='categories_list']").hide();
    //$("#home #helpful_faqs").hide();
    $('[id^="home"]').hide();
    $('#category_show').show();
    $("*[class*='" + subCatClass + "']").show();
    $('#render-search').hide();
    $('#faqs').empty();
  }

  function addBreadCrum(id, CategoryName, type) {

    if (type == 'category')
      $('.breadcrumbs ul').append("<li id='click_" + id + "' > <a href=''> " + CategoryName + " </a> </li>")
    else {
      $('.breadcrumbs ul').append("<li id='sub_" + id + "' > <a href=''> " + CategoryName + " </a> </li>")
    }
  }

  $('.breadcrumbs ul').on('click', "li[id*='click_']", function (e) {
    e.preventDefault();
    var id = $(this).attr('id');
    var categoryName = id.substring(id.indexOf('_') + 1, id.lenght);
    showSubcategory(categoryName);
    $(this).parent().find("li[id*='sub_']").remove();
  });

  $('.breadcrumbs ul').on('click', "li[id*='sub_']", function (e) {
    e.preventDefault();
    return;
  });


  $('#aboutCategory').on('click', function (e) {
    showSubcategory($(this).attr('id'));
    addBreadCrum($(this).attr('id'), 'About T&amp;N', 'category');
  });

  $('#ordersCategory').on('click', function (e) {
    showSubcategory($(this).attr('id'));
    addBreadCrum($(this).attr('id'), 'Orders &amp; Shipping', 'category');
  });

  $('#productCategory').on('click', function (e) {
    showSubcategory($(this).attr('id'));
    addBreadCrum($(this).attr('id'), 'Products', 'category');
  });

  $('#returnsExchangeCategory').on('click', function (e) {
    showSubcategory($(this).attr('id'));
    addBreadCrum($(this).attr('id'), 'Returns &amp; Exchanges', 'category');
  });



  /* $('#inputDatabaseName').on('input',function(e){
      alert('Changed!')
  }); */

  var questions = [
    /*         {
                id: '#question1',
                category: 'Popular',
                question: "What's the difference between ordering through Amazon and Tuft & Needle?",
                answer: 'The return process is the biggest difference when ordering through Amazon. All returns will go directly through Amazon Customer Service, specifically the Special Handling Department. Each product has the same 100-Night Sleep Trial and free returns. The only exceptions are pillows and orders placed through Amazon Canada, which have a 30-Night Sleep Trial.'
            }, */
    // {
    //   id: '#question2',
    //   category: 'Popular', 
    //   question: 'How do I return my mattress?',
    //   answer: 'Subject to certain terms and conditions, your mattress is returnable during the first 100 nights after you receive it. Please reach out to us by emailing help@tuftandneedle.ca to start your return within your 100-Night Trial.<br /><br /> Our return policy allows for one return per household, per year. This means we can only return and refund one mattress purchased within the same year.'
    // },
    {
      id: '#question3',
      category: 'Popular',
      question: 'How do I unbox my mattress?',
      answer: "Position your mattress on top of your bed frame and find the ends of the plastic wrap stuck to the side of the roll. Pull on the end of the plastic until the mattress is completely unrolled. Roll the mattress out so that it's flat, then pull off the remaining plastic. The mattress will begin expanding immediately, and you’re done.<br /><br /> Please note, the mattress will look smaller than normal size until you remove the plastic. If you'd like to see a video of how to unbox your mattress, check it out <a href='https://youtu.be/1eihNoOyIwk' target='_blank'><b>here</b>.</a><br /><br />The plastic packaging we use is recyclable, however, it's an engineered plastic, so it isn't identified by a plastic number. Your local recycling company should be able to better advise as to how to properly dispose of it. <br /><br /> For a more detailed overview on what to do when your mattress arrives, check out <a href='https://tuftandneedle.myshopify.com/blogs/guides/unboxing' target='_blank'><b>this article</b></a> on our blog."
    },
    {
      id: '#question4',
      category: 'Popular',
      question: 'How long will it take for my order to arrive?',
      answer: "For standard shipping, delivery times will vary. You can usually expect delivery of your ordered items within 1-7 business days, with delivery Monday through Friday, excluding holidays.<br /><br />To get a shipping estimate prior to purchase, add the items you wish to order to your cart. Follow the checkout flow and after inputting your shipping address, an ETA will show for each item. There is no need to input your payment information to check.<br /><br />All items ship separately. You will receive a tracking email for each item as it ships out. The tracking information linked in the email will automatically update with the most accurate estimated delivery date as it travels to your home.<br /><br />Please note that orders may take longer to process during or shortly after major holidays or promotional periods. This may mean shipping times will be extended beyond what's listed above."
    },
    /*         {
                id: '#question5',
                category: 'Popular',
                question: 'How do I return my T&N products if I purchased through Amazon?',
                answer: "Any T&N products purchased on Amazon will be returned directly through Amazon.</br></br>To start a return with Amazon for your mattress within the 100-Night Sleep Trial, call 866-423-5353 to reach Amazon’s Special Handling Department. They will be best able to help with your mattress return. Returns through Special Handling do not require you to ship the mattress back to Amazon.</br>To return any product within their individual trial period, such as a pillow, the Amazon-exclusive Nod mattress, protector, pouch, topper, metal base, or box foundation, you will start and complete your return online through your Amazon account.</br>Please keep in mind that pillow orders placed through Amazon.com will only have a 30-Night Sleep Trial. All mattress and pillow orders from Amazon.ca will also only have a 30-Night Sleep Trial.</br>You should not be asked to repackage the mattress for return shipping. If you are directed to repackage and ship the mattress back to return, it is likely you were not routed to the correct Amazon return department and should ask to speak with their Special Handling Department for large-item returns."
            }, */
    {
      id: '#question6',
      category: 'Wheretobuy',
      question: 'Where can I try or purchase Tuft & Needle products in person?',
      answer: 'Tuft & Needle products are not currently available to purchase in person, but check back soon as we’re working hard to get all of our products available to you.'
    },
    {
      id: '#question7',
      category: 'TheDifference',
      question: 'What kind of foam does Tuft & Needle use?',
      answer: 'We use T&N Adaptive<sup>®</sup> foam, which is unique to our company. It provides great pressure relief and support and is comfortable for all sleep styles. Additionally, the heat-wicking graphite and cooling gel in our T&N Adaptive<sup>®</sup> foam work together to help keep you cool while you sleep. <br /><br /> Want to learn more about foam? Visit our blog <a href="https://tuftandneedle.myshopify.com/blogs/products/the_future_of_foam" target="_blank"><b>here</b></a>.'
    },

    {
      id: '#question8',
      category: 'TheDifference',
      question: 'Why are you called Tuft & Needle?',
      answer: 'When JT and Daehee were in the early days of beginning their company, JT asked his neighbour, a master upholsterer, to teach him how to make a mattress. In the process of creating his first mattress, JT learned to tuft the mattress by hand with a large tufting needle.<br /><br />When brainstorming names for the company, JT and Daehee wanted something that sounded authentic, timeless, and modern. JT remembered the tufting needle he used to make his first mattress and decided to call the company "Tuft & Needle". You can read the full story on our blog, linked <a href="/blogs/culture/what_in_the_world_is_a_tuft_-_needle" target="_blank"><b>here</b>.</a>'
    },
    {
      id: '#question9',
      category: 'TheDifference',
      question: 'Where can I read Tuft & Needle reviews?',
      answer: 'We have a number of reviews listed directly on our website, just visit the reviews page to <a href="https://tuftandneedle.myshopify.com/pages/reviews" target="_blank"><b>learn more</b></a>.'
    },
    {
      id: '#question10',
      category: 'Payment',
      question: 'Do you offer financing?',
      answer: 'Yes! We have partnered with PayBright to offer financing or pay-over-time options for our customers. At checkout, you will be given the option to pay through PayBright. Through them, T&N is able to offer 0% financing and $0 down for the first 30 days, as we take on the cost of the loan for you. Monthly payments are then simply billed directly to your credit card or chequing account.<br /><br />Want to learn more about financing a mattress and why we chose to partner with PayBright? Visit our blog <a href="https://help.paybright.com/hc/en-us" target="_blank">here</a>'
    },
    {
      id: '#question101',
      category: 'Payment',
      question: 'How do I use PayBright?',
      answer: '1. Add items to your Cart as usual, and select PayBright as your payment method in Checkout.<br/>2. Complete PayBright’s easy online application and get an instant approval decision.<br/>3. Make 6 monthly payments to PayBright while you fall in love with your new mattress.'
    },
    {
      id: '#question11',
      category: 'Payment',
      question: 'What payment options do you offer?',
      answer: 'We accept payment via credit card (Visa, Mastercard, American Express or Discover), and PayPal. We also offer financing through PayBright.'
    },
    {
      id: '#question12',
      category: 'SameDayShipping',
      question: 'VACIO',
      answer: 'VACIO'
    },
    {
      id: '#question13',
      category: 'StandardShipping',
      question: 'How long will it take for my order to arrive?',
      answer: "For standard shipping, delivery times will vary. You can usually expect delivery of your ordered items within 1-7 business days with delivery Monday through Friday, excluding holidays. <br /><br /> Please note that orders may take longer to process during or shortly after major holidays or promotional periods. This may mean shipping times will be extended beyond what's listed above."
    },
    {
      id: '#question14',
      category: 'StandardShipping',
      question: 'Is shipping free?',
      answer: 'Yes! All of our products are available with a free standard shipping option.* <br><br> *Except in remote postal codes, please follow the check-out process to see if your delivery address falls under this category.'
    },
    {
      id: '#question15',
      category: 'StandardShipping',
      question: 'Do I need to be home to sign for my delivery?',
      answer: 'A signature is not required, so you do not need to be home to sign for delivery. <br /><br /> The driver will leave your package either right at your front door or wherever you typically receive packages. The only time a signature is required is if you’re having your item delivered to a place of business, such as an office building. '
    },
    {
      id: '#question16',
      category: 'StandardShipping',
      question: 'Can I request custom instructions for delivery?',
      answer: "We would be happy to pass along any notes or instructions you may have about your delivery to our shipping partners. Just give us a call at 1-877-496-7151 as soon as you place your order and we'll be sure to hand them off. <br /><br /> Please note that we are unable to call prior to delivery, or pass along gate or door codes to the driver."
    },
    {
      id: '#question17',
      category: 'StandardShipping',
      question: 'Will all of my items ship together?',
      answer: 'All items ship separately. You will receive a tracking email for each item as it ships out. The tracking information linked in the email will automatically update with the most accurate estimated delivery date as it travels to your home.'
    },
    {
      id: '#question18',
      category: 'StandardShipping',
      question: 'Do you ship internationally?',
      answer: 'We only ship within Canada.<br /><br />Our products are also available in the United States at tuftandneedle.com.'
    },
/*     {
      id: '#question19',
      category: 'StandardShipping',
      question: 'Do you ship internationally?',
      answer: 'We only ship within Canada.'
    }, */
    {
      id: '#question20',
      category: 'StandardShipping',
      question: "Where's my tracking information?",
      answer: 'Your tracking information will be emailed to you as soon as your product leaves our facility and is on its way. We recommend keeping an eye on your spam folder as well as your inbox since a lot of business emails are directed there automatically!'
    },
    {
      id: '#question21',
      category: 'StandardShipping',
      question: 'Do you offer removal of my old mattress?',
      answer: 'T&N does not offer mattress removal at this time.'
    },
    {
      id: '#question22',
      category: 'About',
      question: 'What kind of foam does Tuft & Needle use?',
      answer: 'We use T&N Adaptive<sup>®</sup> foam, which is unique to our company. It provides great pressure relief and support and is comfortable for all sleep styles. Additionally, the heat-wicking graphite and cooling gel in our T&N Adaptive<sup>®</sup> foam work together to help keep you cool while you sleep.<br /><br />Want to learn more about foam? Visit our blog <a href="https://tuftandneedle.myshopify.com/blogs/products/the_future_of_foam" target="_blank"><b>here</b></a>.'
    },
    {
      id: '#question23',
      category: 'About',
      question: 'Does the mattress come in custom sizes?',
      answer: "We are unable to provide custom sizes at this time, but contact our support team at help@tuftandneedle.ca if you'd like to be added to our waitlist and notified if this option becomes available.<br /><br />For now, we carry industry standard sizes of twin, twin XL, full, queen, king, and California king. More on those sizes <a href='https://tuftandneedle.myshopify.com/blogs/news' target='_blank'><b>here</b></a>."
    },
    {
      id: '#question24',
      category: 'About',
      question: 'How does The T&N Original Mattress feel?',
      answer: 'The T&N Original Mattress is medium-firm in feel. It was designed to provide great pressure relief with the ideal support for a full night’s sleep. <br /><br /> The mattress stays cool as well. We use cooling gel in our T&N Adaptive<sup>®</sup> foam and our plush cover is extremely breathable to keep you comfortable.<br /><br />To learn more about the feel of a T&N Original Mattress, feel free to check out our blog post <a href="https://tuftandneedle.myshopify.com/blogs/products/post-3"  target="_blank"><b>here</b></a>. Check out customer reviews <a href="https://tuftandneedle.myshopify.com/products/t-n-original-mattress"  target="_blank"><b>here</b></a>.'
    },
    {
      id: '#question25',
      category: 'About',
      question: 'What are the Tuft & Needle mattress dimensions?',
      answer: "The Tuft & Needle Original is a 2-layer mattress that matches industry-standard mattress dimensions.<br /><br />Twin: 75 \"L x 39 \"W x 10\" <br />  Twin XL: 80\"L x 39\"W x 10\"H</br>Full: 75\"L x 54\"W x 10\"H</br>Queen: 80\"L x 60\"W x 10\"H</br>King: 80\"L x 76\"W x 10\"H</br>Cal-King: 84\"L x 72\"W x 10\"H "
    },
    {
      id: '#question26',
      category: 'About',
      question: 'What is the T&N Mattress cover made of?',
      answer: 'The T&N mattress cover is made with a blend of micro polyamide and polyester. It has a soft and plush feel. Micro polyamide is breathable and durable. It keeps you cool and dries up to 8 times faster than cotton. Our mattress cover is resistant to pilling and tearing.<br /><br />The Original mattress cover is not waterproof or removable/washable, so if there are any concerns, we’d recommend using a mattress protector.'
    },
    {
      id: '#question27',
      category: 'About',
      question: 'What certifications does the T&N Original Mattress have?',
      answer: "The foams used in our T&N Original Mattress are tested and certified by CertiPUR-US<sup>®</sup>, a 3rd-party foam certifier, to be free from known harmful chemicals and gasses. More specifically, our foams are tested to be free from ozone depleters, PBDE flame retardants, heavy metals, formaldehyde, phthalates, and low VOC (Volatile Organic Compound) emissions for indoor air quality (less than 0.5 parts per million).<br /><br />For more information, check out CertiPUR-US<sup>®</sup>'s website <a href='http://certipur.us/technical-guidelines/'  target='_blank'><b>here</b></a>.<br /><br />We have the UL GREENGUARD Gold Certification for the entire T&N mattress. GREENGUARD Certified products aid in the creation of healthier indoor environments, and release fewer pollutants that can contribute to health issues including asthma and other respiratory issues. This GREENGUARD label validates that the T&N mattress is low-emitting and supports healthy indoor environments. UL is a global independent safety science company with more than a century of expertise innovating safety solutions.<br /><br />For more information, check out the GREENGUARD Certification website <a href='http://greenguard.org/en/index.aspx'  target='_blank'><b>here</b></a>. We\'re also certified by Intertek, which is a similar testing and certification process to GREENGUARD. For more information on their process, visit <a href='http://www.intertek.com/certification/indoor-air-quality/'  target='_blank'><b>here</b></a>.<br /><br />Want to learn more about certifications? Visit our blog <a href='https://tuftandneedle.myshopify.com/pages/blogs'  target='_blank'><b>here</b></a>."
    },
    {
      id: '#question28',
      category: 'About',
      question: 'Is there any latex in the Tuft & Needle mattresses?',
      answer: "We don't use any natural latex or latex foam in our mattress; however, we do use a small amount of synthetic latex as the adhesive between the foam layers. The adhesive lives beneath the cover of the mattress and should not come into direct contact with the body while sleeping."
    },
    {
      id: '#question29',
      category: 'About',
      question: 'What kind of testing and labeling does Tuft & Needle do? ',
      answer: 'Tuft & Needle believes in a culture of well-being. We comply with both the letter and spirit of the law, whether federal, provincial or local. At Tuft & Needle we are committed to going above and beyond during the design, sourcing, and manufacture of our products.<br /><br />Because of this, we’re committed to testing and certifying our products through third-party and CPSC-accredited labs, where applicable, against strict product standards such as CertiPUR-US<sup>®</sup>, GREENGUARD GOLD, and Intertek. If you have any further questions,feel free to reach out to our team for help. We are proud of our commitment to excellence.<br /><br />Want to learn more about certifications? Visit our blog <a href="https://tuftandneedle.myshopify.com/pages/blogs"  target="_blank"><b>here</b></a>.'
    },
    {
      id: '#question30',
      category: 'ShippingDelivery',
      question: 'Do you ship internationally?',
      answer: 'We only ship within Canada.<br /><br />Our products are also available in the United States at tuftandneedle.com'
    },
    {
      id: '#question31',
      category: 'ShippingDelivery',
      question: 'Do you ship to where I live?',
      answer: 'We are constantly expanding the areas where our products are available! There may be an additional charge for shipping to certain locations.<br /><br />This charge will be reflected in your shopping cart as you check out so you can view the full cost before you purchase.<br /><br /><b>Please note that in the event of a return, the extra shipping cost will not be refunded.</b>'
    },
    {
      id: '#question32',
      category: 'ShippingDelivery',
      question: 'What are the shipping dimensions for the T&N Original Mattress?',
      answer: 'The box for the twin, twin XL, full, and queen is 16"L X 16"W X 44"H.<br /><br />The box for the king and Cal king is 19"L X 19"W X 44"H.<br /><br />Shipping weights for the mattress are as follows:<br /><br />Twin: 50 lbs</br>Twin XL: 52 lbs</br>Full: 63 lbs</br>Queen: 72 lbs</br>King/Cal king: 94 lbs<br /><br />Shipping weight for the mattress can vary between 5-6 lbs because of packaging. You can view all of the shipping info on our Shop page <a href="https://tuftandneedle.myshopify.com/products/t-n-original-mattress"  target="_blank"><b>here</b></a>.'
      
    },
    {
      id: '#question33',
      category: 'SetupCare',
      question: 'How do I unbox my mattress?',
      answer: "Position your mattress on top of your bed frame and find the ends of the plastic wrap stuck to the side of the roll. Pull on the end of the plastic until the mattress is completely unrolled. Roll the mattress out so that it's flat, then pull off the remaining plastic. The mattress will begin expanding immediately, and you’re done.<br /><br />Please note, the mattress will look smaller than normal size until you remove the plastic. If you'd like to see a video of how to unbox your mattress, check it out <a href='https://youtu.be/dD03Gz_nsiY' target='_blank'><b>here</b></a>.<br /><br />The plastic packaging we use is recyclable, however, it's an engineered plastic, so it isn't identified by a plastic number. Your local recycling company should be able to better advise as to how to properly dispose of it.<br /><br />For a more detailed overview on what to do when your mattress arrives, check out <a href='https://tuftandneedle.myshopify.com/blogs/guides/unboxing' target='_blank'><b>this article</b>.</a>"
    },
    {
      id: '#question34',
      category: 'SetupCare',
      question: 'Does the Tuft & Needle Original mattresses require a box spring?',
      answer: "No, a box spring is not required if your current setup provides enough even support. You do not need to replace your current box spring if it is still in great shape.<br /><br />The mattress needs to be supported at all times, so platform frames, slatted frames, bunky boards, and even adjustable frames will support our mattress without requiring a box spring. The space between individual slats should be fewer than 5” for the right support."
    },
    {
      id: '#question35',
      category: 'SetupCare',
      question: 'Will the mattress smell or off-gas?',
      answer: "Some people notice a new mattress smell for a few days, but it goes away quickly. Initially, we suggest letting the mattress air out by removing any sheets or mattress protector that cover it. Do not remove the fabric cover that comes with the mattress. The smell comes from the freshly new foam being packaged during transit and not from any harmful chemicals. We've been certified by CertiPUR-US<sup>®</sup> and GREENGUARD Gold to be free from many known harmful chemicals or gasses.<br /><br />You can learn more about our CertiPUR-US<sup>®</sup> certification and what they test for <a href='http://certipur.us/technical-guidelines/'  target='_blank'><b>here</b></a> and our GREENGUARD Gold certification and what they test for <a href='http://greenguard.org/en/index.aspx' target='_blank'><b>here</b></a>."
    },
    {
      id: '#question36',
      category: 'SetupCare',
      question: 'Can I remove the mattress cover for cleaning?',
      answer: "The mattress cover is <u>not</u> meant to be removed. The zipper is only there to help our manufacturers put on the cover, and the zipper is clipped to prevent removal.<br /><br />Because the cover cannot be removed, we recommend spot cleaning it when needed. We suggest using a small amount of mild detergent and water and gently dabbing the cover, rather than rubbing it. Make sure the cleaned area is completely dry before placing sheets and blankets back on the mattress.<br /><br />For more information about how to clean your cover, this <a href='https://tuftandneedle.myshopify.com/blogs/culture/the-best-ways-to-clean-your-mattress' target='_blank'><b>blog post</b></a> has some helpful tips and tricks for caring for your mattress."
    },

    {
      id: '#question37',
      category: 'SetupCare',
      question: 'How long can I leave the mattress in the box?',
      answer: 'We suggest unboxing your mattress soon after delivery—within 3-4 weeks of delivery is ideal. '
    },
    {
      id: '#question38',
      category: 'SetupCare',
      question: 'Can I use my mattress on the floor?',
      answer: 'For the best care when sleeping on the floor, prop your mattress up against a wall to refresh the airflow once or twice a week; this will help keep your mattress dry and clean.<br /><br />With all mattresses, there is a chance of mildew when it lacks airflow, especially over an organic (e.g. cotton rug, plywood) or moist surface. Mold is not covered by our warranty, so if you live in a humid climate, we highly recommend that you use a bed frame or bunky board that lifts the mattress off the ground.'
    },
    {
      id: '#question39',
      category: 'SetupCare',
      question: 'What do I do with my old mattress? ',
      answer: "Once your Tuft & Needle mattress arrives, we suggest donating your old mattress to an organization, such as Salvation Army, Habitat for Humanity, or St. Vincent de Paul. Local churches, community centres and homeless shelters are also great options!<br /><br />Keep in mind that in order to donate used mattresses, they need to be free from rips, tears, and stains. You may be able to utilize a recycling service in your area to remove your old mattress for a small fee if a charity won't accept the donation."
    },
    {
      id: '#question40',
      category: 'SetupCare',
      question: 'How long do I need to wait before sleeping on my new mattress?',
      answer: "Though we do recommend letting your mattress air out and expand for 2-3 hours after unboxing for the best feel, you're welcome to sleep on it right away!<br /><br />The break-in period for the mattress is usually about 2-3 weeks. During this time, the foam of the mattress expands fully and becomes both softer and more supportive with use, providing the best pressure relief for your sleep. If for any reason you're uncomfortable after breaking in the mattress, please reach out! We'd be happy to troubleshoot."
    },
    {
      id: '#question41',
      category: 'SetupCare',
      question: 'Do I need to flip or rotate my mattress?',
      answer: "We recommend rotating your T&N mattress every 6 months, but there's no need to flip the mattress as the foam core has been designed to have a specific top and bottom. Always keep the zippered side down for optimal comfort."
    },
    {
      id: '#question42',
      category: 'SetupCare',
      question: 'How do I move my T&N mattresses?',
      answer: "Tuft & Needle mattresses cannot be recompressed after expanding.<br /><br />Use a mattress bag to protect your mattress from water, dust, and wear and tear.<br /><br />Using straps to secure the mattress (like in a moving truck) shouldn't damage the foam, so feel free to use those options if necessary."
    },
    {
      id: '#question43',
      category: 'SetupCare',
      question: 'How do I get urine out of the mattress?',
      answer: "Soak up extra liquid using 4-5 layers of paper towels: Apply pressure to the spot on the mattress to absorb as much liquid as possible. Repeat this as many times as necessary.<br /><br />Spot clean the area with baking soda, vinegar or mild detergents like Dawn dishwashing detergent.<br /><br />Vinegar and baking soda will help remove unwanted odors.<br /><br />We recommend making sure the cleaned area is completely dry before placing sheets and blankets back on the mattress.<br /><br />Please note the built-on mattress cover is not meant to be removed. Check out our blog post <a href='/blogs/guides/how-to-get-urine-out-of-a-mattress'  target='_blank'><b>How to Get Urine Out of a Mattress</b></a> for detailed steps on removing urine from the mattress."
    },
    {
      id: '#question44',
      category: 'SetupCare',
      question: 'Should I use a mattress protector?',
      answer: 'We recommend using a protector if you’re concerned about accidents, spills, stains, or simply keeping your mattress cover clean since the covers on our mattresses are not removable or washable.'
    },
    {
      id: '#question45',
      category: 'SetupCare',
      question: 'What kind of sheets will fit the Tuft & Needle mattresses?',
      answer: 'Standard bed sheets will fit the T&N Original Mattress best. Be sure to steer clear of deep-pocketed sheets as they may end up being too big.'
    },
    {
      id: '#question46',
      category: 'SetupCare',
      question: 'Can I use a heating pad with my T&N mattress?',
      answer: "Yes, using a heating pad on your Tuft & Needle mattress won't cause any long-term damage to the foam or void the limited warranty coverage, so get cozy!"
    },
    {
      id: '#question47',
      category: 'SetupCare',
      question: 'Can I recycle the plastic packaging the mattress comes in?',
      answer: "The plastic packaging we use is recyclable, however, it's an engineered plastic, so it isn't identified by a plastic number. Your local recycling company should be able to better advise as to how to properly dispose of it."
    },
    {
      id: '#question48',
      category: 'SetupCare',
      question: 'Can I cut, alter, modify, or reconfigure my mattress?',
      answer: 'It is crucial that our mattresses never be cut, altered, modified or otherwise reconfigured. Doing so may affect the safety characteristics of the product, including the fire-resistant barrier within the mattress. Our mattresses are carefully designed in order to meet stringent flammability requirements. As such, it is imperative that its overall size [or dimensions] not be altered in any way. Additionally, altering the mattress in any way will void the 10-year limited warranty on the mattress.'
    },
    {
      id: '#question49',
      category: 'ReturnsExchanges',
      question: 'How do I return my mattress?',
      answer: "Subject to certain terms and conditions, your mattress is returnable during the first 100 nights after you receive it. Please reach out to us by emailing help@tuftandneedle.ca to start your return within your 100-Night Trial.<br><br>Optional shipping fees are non-refundable.<br /><br />Our return policy allows for one return per household, per year. This means we can only return and refund one mattress purchased within the same year."
    },
    {
      id: '#question50',
      category: 'ReturnsExchanges',
      question: 'What can I do if I think the mattress is too soft?',
      answer: "If the mattress is too soft for you, we recommend checking your foundation to make sure the mattress is properly supported. You can learn more about appropriate foundations on our blog post, <a href='/blogs/products/everything-you-ever-needed-to-know-about-foundations'  target='_blank'><b>Everything You Ever Needed To Know About Foundations</b></a>.<br /><br />If you’re using a proper foundation and still find the mattress to be too soft, we recommend moving forward with a return. You can learn about returns <a id='jumpToQuestion' data-jump='#question49' href=''><b>here</b>.</a>"
    },
    {
      id: '#question51',
      category: 'Warranty',
      question: 'What is your mattress warranty?',
      answer: "Our <a href='/pages/warranty' target='_blank'><b>10-year limited warranty</b></a> covers manufacturing defects, such as compressions deeper than 3/4\", sagging, flaws in the foam causing it to split or crack, and cover defects, such as unraveling stitching.<br><br>We don't cover changes to your mattress that are caused by normal wear and tear or that result from circumstances or uses that go beyond the intended use of a mattress—namely, reclining and sleeping.<br><br>If you believe you’re experiencing a defect in your mattress covered under its warranty, please email us at help@tuftandneedle.ca."
    },
    // {
    //   id: '#question52',
    //   category: 'Warranty',
    //   question: 'Can I get a replacement mattress cover?',
    //   answer: "Our mattress covers are not removable, so we’re unable to provide replacement covers.<br><br />The <a href='/pages/100-night-trial' target='_blank'><b>10-year limited warranty</b></a> covers any damages in the cover due to defects in materials and workmanship when used normally for a period of 10 years from the date of original purchase.<br /><br />Send us an email at help@tuftandneedle.ca if you've had a warranty issue pertaining to the cover and we'd be happy to help."
    // },
    // {
    //   id: '#question53',
    //   category: 'OriginalMattress',
    //   question: 'How do I return my mattress?',
    //   answer: "Subject to certain terms and conditions, your mattress is returnable during the first 100 nights after you receive it. Please reach out to us by emailing help@tuftandneedle.ca to start your return within your 100-Night Trial.<br /><br />Optional shipping fees are non-refundable.<br /><br />Our return policy allows for one return per household, per year. This means we can only return and refund one mattress purchased within the same year."
    // },
    // {
    //   id: '#question54',
    //   category: 'OriginalMattress',
    //   question: 'What is the 100-Night Sleep Trial?',
    //   answer: "If the mattress ends up not being the right fit for you within the first 100 nights, we'll help you with a return and full refund.*</br></br>To return the T&N Original Mattress you ordered through us directly, email us at help@tuftandneedle.ca to get your return started.<br /><br />Our return policy does only allow for one return per household per year, so we can only return and refund one mattress purchased within the same year.<br /><br />* Optional shipping fees are non-refundable."
    // },
    {
      id: '#question55',
      category: 'CancelingOrder',
      question: 'How can I cancel my order?',
      answer: "To cancel your entire order, simply follow the link to your order summary that was sent to your email. Once you have your order summary page open, click “cancel order” and you’ll be all set!<br /><br />To cancel just one item on your order, reach out to our team as soon as possible by phone at 1-877-496-7151 and we'd be happy to help. Once your order has been cancelled, your funds will be processed back into your original purchasing card or account within 5-10 business days."
    },
    // {
    //   id: '#question56',
    //   category: 'Mattresses',
    //   question: 'How do I exchange my Tuft & Needle products?',
    //   answer: "If you're still within your 100-Night Sleep Trial and purchased directly through Tuft & Needle, you do have the ability to exchange for a new product.<br /><br />Give us a call at 1-877-496-7151 so we can walk you through the process. We'll place your new order over the phone, charge the difference in cost between the two items (or refund the difference accordingly), and walk you through the steps for the removal of the original product.<br /><br />Please keep in mind that an exchange will void the sleep trial for the new product. You can learn more about our 10-year limited warranty <a href='https://tuftandneedle.myshopify.com/pages/100-night-trial' target='_blank'><b>here</b></a>."
    // },
    {
      id: '#question57',
      category: 'OriginalMattress2',
      question: 'What is your mattress warranty?',
      answer: "Our <a href='/pages/warranty' target='_blank'><b>10-year limited warranty</b></a>. covers manufacturing defects, such as compressions deeper than 3/4\", sagging, flaws in the foam causing it to split or crack, and cover defects, such as unraveling stitching.<br /><br />We don't cover changes to your mattress that are caused by normal wear and tear or that result from circumstances or uses that go beyond the intended use of a mattress—namely, reclining and sleeping.<br /><br />If you believe you’re experiencing a defect in your mattress covered under its warranty, please email us at help@tuftandneedle.ca."
    },
    {
      id: '#question58',
      category: 'OriginalMattress2',
      question: 'Can I get a replacement mattress cover?',
      answer: "Our mattress covers are not removable, so we’re unable to provide replacement covers.<br /><br />The <a href='/pages/100-night-trial' target='_blank'><b>10-year limited warranty</b></a> covers any damages in the cover due to defects in materials and workmanship when used normally for a period of 10 years from the date of original purchase.<br /><br />Send us an email at help@tuftandneedle.ca if you've had a warranty issue pertaining to the cover and we'd be happy to help."
    },
    {
      id: '#question59',
      category: 'OriginalMattress2',
      question: "Why is the mattress's limited warranty only 10 years?",
      answer: 'Warranties that are more than 10 years are generally prorated, which means for every year you own it, you would receive less and less credit. It is also suggested that mattresses be replaced every 8-10 years for hygienic reasons.'
    },
    {
      id: '#question60',
      category: 'OriginalMattress2',
      question: 'Why does my mattress feel softer than it did when I first received it?',
      answer: 'If you feel like your mattress is feeling a little softer where you sleep, you’re in the norm!<br /><br />Like your favorite spot on the couch, it’s normal for the mattress to feel a little softer or more broken in over time. Similarly, depending on where in the bed you sleep each night, it’s normal for the areas where you sleep regularly to be more broken in than parts of the bed that get less use.<br /><br />One thing you can do moving forward is to rotate the mattress head to foot every six months or so, allowing the mattress to break in more evenly as time goes on.'
    },
    {
      id: '#question61',
      category: 'OriginalMattress2',
      question: 'How do I register my mattress for the limited warranty?',
      answer: "There's no paperwork needed to register your <a href='https://tuftandneedle.myshopify.com/pages/warranty' target='_blank'><b>limited warranty</b></a> when you purchase from T&N directly; we can access your order through the email address you used when you placed your order.<br /><br />For all warranty concerns, please email us at help@tuftandneedle.ca with pictures of the issue, as well as pictures of the tags on the mattress."
    }
  ]



  /*Contact Information JqueryValidation*/

  var contactFormValidation = function () {
    var myform = $("#faq-contact");

    myform.on("submit", function (ev) {
      ev.preventDefault();

      if (!$('#faq-contact').valid())
        return;

      $.ajax({
        type: myform.attr('method'),
        url: myform.attr('action'),
        async: true,
        data: myform.serialize(),
        success: function (data) {
          console.log('success');
          $('#contactForm').hide();
          $('#emailSuccess').show();
          myform[0].reset();
        },
        error: function error(xhr, ajaxOptions, thrownError) {
          console.log(thrownError);
          // some code here
        }
      });


    });
  }

  contactFormValidation();

  $('#faq-contact').validate({
    rules: {
      'contact[Name]': {
        required: true,
        minlength: 2
      },
      'contact[email]': {
        required: true,
        email: true
      },
      'contact[contactConcern]': "required",
      'contact[Message]': "required"

    },
    messages: {
      'contact[Name]': {
        required: "Please enter full name",
        minlength: "Your full name must consist of at least 2 characters"
      },
      'contact[email]': {
        required: "Please enter email address",
        email: "Please enter a valid email address"
      },
      'contact[contactConcern]': "Please select a reason for reaching out",
      'contact[Message]': "Please enter your message"

    },
    errorElement: "em",
    errorPlacement: function (error, element) {
      // Add the `invalid-feedback` class to the error element
      error.addClass("invalid-feedback");

      if (element.prop("type") === "checkbox") {
        error.insertAfter(element.next("label"));
      } else {
        error.insertAfter(element[0].previousElementSibling);

        //error.insertAfter(element);
      }
    },
    highlight: function (element, errorClass, validClass) {
      $(element).addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).addClass("is-valid").removeClass("is-invalid");
    }
  });
  //Contact Form Submit and validation
  /*$('#faq-contact').validate({
   rules: {
     'contact[Name]': {
       required: true,
       minlength: 2
     }
     , 
     'contact[email]': {
       required: true,
       email: true
     },
     contactConcern: "required",
     Message:"required"
   },
   messages: {
     Name:{
       required: "Please enter full name",
       minlength: "Your full name must consist of at least 2 characters"
     },
    email:{
       required: "Please enter email address",
       email:"Please enter a valid email address"
    },
    contactConcern:"Please select a reason for reaching out",
    Message: "Please enter your message"
   }
 }); */

});





